const MATERIAL_SYMBOL_FONT =
  "https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,600,0..1,-50..200";

const ensureMaterialFont = () => {
  if (typeof document === "undefined") {
    return;
  }

  const exists = document.head.querySelector<HTMLLinkElement>(
    `link[rel="stylesheet"][href="${MATERIAL_SYMBOL_FONT}"]`,
  );

  if (exists) {
    return;
  }

  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = MATERIAL_SYMBOL_FONT;
  document.head.appendChild(link);
};

const setExpandedState = (
  trigger: HTMLButtonElement,
  panel: HTMLElement,
  item: HTMLElement | null,
  expanded: boolean,
) => {
  trigger.setAttribute("aria-expanded", expanded ? "true" : "false");
  panel.setAttribute("aria-hidden", expanded ? "false" : "true");
  panel.dataset.expanded = expanded ? "true" : "false";

  if (expanded) {
    item?.classList.add("is-open");
  } else {
    item?.classList.remove("is-open");
  }
};

const bindAccordion = (root: HTMLElement) => {
  if (root.dataset.accordionBound === "true") {
    return;
  }

  root.dataset.accordionBound = "true";

  const triggers = Array.from(
    root.querySelectorAll<HTMLButtonElement>("[data-accordion-trigger]"),
  );
  const isSingle = root.dataset.accordionSingle === "true";

  triggers.forEach((trigger) => {
    const panelId = trigger.getAttribute("aria-controls");
    if (!panelId) {
      return;
    }

    const panel = root.querySelector<HTMLElement>(`[id="${panelId}"]`);
    if (!panel) {
      return;
    }

    const item = trigger.closest<HTMLElement>(".sts-block-accordion-grid__item");
    const getIsExpanded = () => trigger.getAttribute("aria-expanded") === "true";

    setExpandedState(trigger, panel, item, getIsExpanded());

    trigger.addEventListener("click", () => {
      const nextExpanded = !getIsExpanded();

      if (isSingle && nextExpanded) {
        triggers
          .filter((other) => other !== trigger)
          .forEach((other) => {
            const otherPanelId = other.getAttribute("aria-controls");
            if (!otherPanelId) {
              return;
            }
            const otherPanel = root.querySelector<HTMLElement>(`[id="${otherPanelId}"]`);
            const otherItem = other.closest<HTMLElement>(".sts-block-accordion-grid__item");
            if (otherPanel) {
              setExpandedState(other, otherPanel, otherItem, false);
            }
          });
      }

      setExpandedState(trigger, panel, item, nextExpanded);
    });

    trigger.addEventListener("keydown", (event) => {
      if (event.defaultPrevented) {
        return;
      }

      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        const nextExpanded = !getIsExpanded();

        if (isSingle && nextExpanded) {
          triggers
            .filter((other) => other !== trigger)
            .forEach((other) => {
              const otherPanelId = other.getAttribute("aria-controls");
              if (!otherPanelId) {
                return;
              }
              const otherPanel = root.querySelector<HTMLElement>(`[id="${otherPanelId}"]`);
              const otherItem = other.closest<HTMLElement>(".sts-block-accordion-grid__item");
              if (otherPanel) {
                setExpandedState(other, otherPanel, otherItem, false);
              }
            });
        }

        setExpandedState(trigger, panel, item, nextExpanded);
      }
    });
  });
};

const initAccordions = () => {
  ensureMaterialFont();

  const wrappers = Array.from(
    document.querySelectorAll<HTMLElement>(".sts-block-accordion-grid"),
  );
  wrappers.forEach(bindAccordion);
};

if (typeof document !== "undefined") {
  if (document.readyState !== "loading") {
    initAccordions();
  } else {
    document.addEventListener("DOMContentLoaded", initAccordions);
  }
}
